import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { gql } from "@apollo/client";
import { client } from "..";


const GET_EMPLOYEE_ACCESS = gql`
  query GetEmployeeAccess($employeeId: String!) {
    getEmployeeAccess(employeeId: $employeeId) {
      _id
      employeeId
      employeeName
      employeeDepartment
      routes
      employees
      updateHistory {
        changedBy
        changedAt
        changeType
        affectedRoutes
        note
      }
      createdBy
      createdAt
      updatedBy
      updatedAt
      status
    }
  }
`;
// Initial state for the employee slice
export const fetchEmployeeAccess = createAsyncThunk(
  "employeeAccess/fetchEmployeeAccess",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: GET_EMPLOYEE_ACCESS,
        variables: { employeeId: userId },
        fetchPolicy: 'network-only', // Changed from 'no-cache'
      });

      const employeeAccess = data?.getEmployeeAccess;

      if (!employeeAccess) {
        return rejectWithValue('Employee access not found');
      }

      return employeeAccess;
    } catch (error) {
      return rejectWithValue(error?.message || error?.graphQLErrors?.[0]?.message || 'Failed to fetch employee access');
    }
  }
);
const initialState = {
  currentEmployeeAccess: null,
  userData: {},
  managersData: [],
  clientHistory: [],
  employmentData: {},
  sidemenu: [],
  route: [],
  fields: [],
  personalInfo: {},
  designation: {},
  workExperience: {},
  emergencyContacts: [],
  workHistory: [],
  reportsDatas: [],
  educationData: [],
  experienceData: [],
  familyMembers: [],
  attachmentsHistory: [],
  AllEmployees: [],
  clients: [],
  MainClient: [],
  id: true,
  editHistory: {
  totalCount: 0,
  history: []
},
  profileDate: [],
  filteredLeaveData: null,
  button: false,
  selectedMailsData: [],
  checkedMailsData: [],
  selectedEmails: [],
  notes: [
    { name: "documentNote", status: true, data: "" },
    { name: "teamNote", status: true, data: "" },
    { name: "familyNote", status: true, data: '' },
    { name: "workNote", status: true, data: "" },
    { name: "clientNote", status: true, data: "" },
    { name: "EducationNote", status: true, data: "" }
  ],
};

// Create the employee slice
const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
        clearCurrentEmployeeAccess: (state) => {
          state.currentEmployeeAccess = null;
          state.employeeError = null;
        },
    setUserDatas: (state, action) => {
      state.userData = action.payload;
    },
    setBtn(state, action) {
      state.button = action.payload
    },
    setManagersDatas: (state, action) => {
      state.managersData = action.payload;
    },
    setClientHistorys: (state, action) => {
      state.clientHistory = action.payload;
    },
    setEmploymentDatas: (state, action) => {

      state.employmentData = action.payload;
    },
    setPersonalInfos: (state, action) => {
      state.personalInfo = action.payload;
    },
    setDesignations: (state, action) => {
      state.designation = action.payload;
    },
    setWorkExperiences: (state, action) => {
      state.workExperience = action.payload;
    },
    setEmergencyContactes: (state, action) => {
      state.emergencyContacts = action.payload;
    },
    setBankInfos: (state, action) => {
      state.BankInfos = action.payload;
    },
    setWorkHistorys: (state, action) => {
      state.workHistory = action.payload;
    },
    setReportsDatas: (state, action) => {
      state.reportsDatas = action.payload;
    },
    setEducationDatas: (state, action) => {
      state.educationData = action.payload;
    },
    setExperienceDatas: (state, action) => {
      state.experienceData = action.payload;
    },
    setFamilyMemberses: (state, action) => {
      state.familyMembers = action.payload;
    },
    setAttachmentsHistorys: (state, action) => {
      state.attachmentsHistory = action.payload instanceof Array ? action.payload : [...state.attachmentsHistory, action.payload];
    },


    SetAllEmployees: (state, action) => {

      state.AllEmployees = action.payload
        .map(emp => ({
          ...emp,
          token: emp.token || "N/A"
        }))
        .sort((a, b) => a.firstname.localeCompare(b.firstname));
    },

    updateEditHistory: (state, action) => {
      state.editHistory = action.payload;
    },

    setEditHistory: (state, action) => {
      state.editHistory = {
        totalCount: state.editHistory.totalCount + 1,
        history: [action.payload, ...state.editHistory.history],
      }
    },
    SetNewEmployees: (state, action) => {

      state.AllEmployees = [action.payload, ...state.AllEmployees];

    },
    setClients: (state, action) => {
      state.clients = action.payload;
    },
    setId: (state, action) => {
      state.id = action.payload;
    },
    setAllNotes(state, action) {
      const { name, data } = action.payload;
      state.notes = state.notes.map((note) => {
        if (note.name === name) {

          return {
            ...note,
            data: data,
            status: false,
          };
        }
        // If the note name does not match, return it unchanged
        return note;
      });
    },
    updateNoteData(state, action) {
      const { name, data } = action.payload;

      const note = state.notes.find((item) => item.name === name);
      if (note) {
        note.data = data;
      }
    },
    setAllNote(state, action) {
      state.notes = state.notes.map((note) => ({
        ...note,
        status: true,
        data: null,
      }));
    },
    setProfileData(state, action) {
      state.profileDate = action.payload;
    },
    setImg(state, action) {
      state.img = action.payload
    },
    setFields(state, action) {
      state.fields = action.payload;
    },
    addField(state, action) {
      state.fields.push(action.payload);
    },
    updateField(state, action) {
      const { fieldId, docId, newData } = action.payload;
      const field = state.fields.find((f) => f._id === fieldId);
      if (field) {
        const document = field.data.find((doc) => doc._id === docId);
        if (document) {
          Object.assign(document, newData);
        }
      }
    },
    deleteField(state, action) {
      const { fieldId, docId } = action.payload;
      const field = state.fields.find((f) => f._id === fieldId);
      if (field) {
        field.data = field.data.filter((doc) => doc._id !== docId);
      }
    },
    SideMenu(state, action) {
      // Update the sidemenu state
      state.sidemenu = action.payload;
      // Log the updated sidemenu
    },
    setRoutes(state, action) {
      state.route = action.payload
    },
    setFilteredLeaveData(state, action) {
      state.filteredLeaveData = action.payload; // Store the object in state
    },
    setSelectedMailsData: (state, action) => {
      state.selectedMailsData = action.payload
    },
    setCheckedMailsData(state, action) {
      state.checkedMailsData = action.payload;
    },
    setSelectedMails(state, action) {
      state.selectedEmails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeAccess.fulfilled, (state, action) => {
        state.currentEmployeeAccess = action.payload;
      })
      .addCase(fetchEmployeeAccess.rejected, (state, action) => {
        state.currentEmployeeAccess = null;
        state.employeeError = action.payload;
      });
  }
});
// Exporting actions to be used in components
export const {
  setUserDatas,
  SideMenu,
  setRoutes,
  setProfileData,
  setManagersDatas,
  setClientHistorys,
  setBankInfos,
  setId,
  setFields,
  setBtn,
  addField,
  updateField,
  deleteField,
  setLoading,
  setAllNote,
  setAllNotes,
  setNoteStatus,
  setEmploymentDatas,
  setPersonalInfos,
  setImg,
  setDesignations,
  updateEditHistory,
  setWorkExperiences,
  setEmergencyContactes,
  setWorkHistorys,
  setMainClient,
  setReportsDatas,
  setEducationDatas,
  setExperienceDatas,
  setFamilyMemberses,
  updateNoteData,
  setAttachmentsHistorys,
  setNotes,
  updateStatus,
  SetAllEmployees,
  SetNewEmployees,
  setClients,
  setEditHistory,
  updateEmployeeToken,
  setFilteredLeaveData,
  setSelectedMailsData,
  setCheckedMailsData,
  setSelectedMails

} = employeeSlice.actions;
// Exporting the reducer to be used in the store
export default employeeSlice.reducer;

